<template>
  <div class="listPage">
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="TracksList.length > 0" style="overflow:auto">
      <b-table hover
        class="table table-striped"
        style="margin-bottom:0"
        :fields="fields"
        :items="TracksList"
        :selectable="TracksList.length > 0"
        :empty-text="$t('common.no_result')"
        @row-clicked="seeTracksDetails"
        role="table"
        :aria-label="$t('tracking.tracking_list_table')"
        sticky-header
        thead-class="text-center"
        tbody-class="text-center">
        <template #cell(Date)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(StatusFile)="data">
          <span>{{ translateStatusFile(data.value) }}</span>
        </template>
        <template #cell(FinalStatus)="data">
          <span>{{ translateFinalStatus(data.value) }}</span>
        </template>
        <template #cell(FileType)="data">
          <span>{{ translateFileType(data.value) }}</span>
        </template>
        <template #cell(bic_from)="data">
          <span>{{ data.value }}</span>
        </template>
      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col>
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download";


export default {
  name: 'TrackingBulkPage',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    filters: {
      type: Object,
      default: () => ({
        Name: '',
        dateBegin: '',
        dateEnd: ''
      })
    },
    displayFilter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      fields = [
        { key: 'Silo', label: this.$i18n.t('tracking.silo'), class: 'text-center', sortable: false },
        { key: 'Date', label: this.$i18n.t('tracking.reception_date'), class: 'text-center', sortable: false },
        { key: 'FileType', label: this.$i18n.t('tracking.file_type'), class: 'text-center', sortable: false },
        { key: 'bic_from', label: this.$i18n.t('tracking.entity_emitter'), class: 'text-center', sortable: false },
        { key: 'FileName', label: this.$i18n.t('tracking.file_name'), class: 'text-center', sortable: false },
        { key: 'NbRequests', label: this.$i18n.t('tracking.nb_requests'), class: 'text-center', sortable: false },
        { key: 'StatusFile', label: this.$i18n.t('tracking.processing_state'), class: 'text-center', sortable: false },
        { key: 'FinalStatus', label: this.$i18n.t('tracking.final_status'), class: 'text-center', sortable: false },
        //{ key: 'ProcessingState', label: this.$i18n.t('tracking.processing_state'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.filters.Name ||
          this.filters.dateBegin || this.filters.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      timezone: '+00:00',
      //engineIndex: 0,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      identifier: '',
      technicalStatus: '',
      IBAN: '',
      tabName: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      trackActive: '',
      TracksList: [],
      _onApplyFilters: null,
      _onRefreshBulk: null,
      _onExportBulk: null,
      _busBound: false,   // évite les re-bind du bus
      _exporting: false,  // empêche 2 exports simultanés
    }
  },
  created () {
    this.timezone = moment.tz.guess()

    if (this.type == 'DDV'){
      this.tabName = 1
    }else{
      this.tabName = 2
    }
    // this.$bus.$emit('switch-selected-menu', '/trackingbulk/:id')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered-bulk'
    this.$bus.$off('direct-inbox-filtered-bulk')
    this.$bus.$on('direct-inbox-filtered-bulk', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    // // Écouter les événements de filtres du parent
    // this.$bus.$off('apply-filters-tracking-bulk')
    // this.$bus.$on('apply-filters-tracking-bulk', (filters) => {
    //   this.applyFilter()
    // })
    //
    // this.$bus.$off('refresh-tracking-bulk')
    // this.$bus.$on('refresh-tracking-bulk', () => {
    //   this.onRefresh(false)
    // })
    //
    // this.$bus.$off('export-tracking-bulk')
    // this.$bus.$on('export-tracking-bulk', () => {
    //   this.extractCSV()
    // })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)

    this.$bus.$emit('right-panel-set-feature', 'filter-messages')

    // préparer nos handlers nommés
    this._onApplyFilters = () => this.applyFilter()
    this._onRefreshBulk  = () => this.onRefresh(false)
    this._onExportBulk   = () => this.extractCSV()

    // premier bind (au cas où la page n’est pas keep-alive)
    this.bindBus()
  },
  activated () {
    // si la page revient au premier plan
    this.bindBus()
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },

  deactivated () {
    this.unbindBus()
  },

  beforeDestroy () {
    this.unbindBus()
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  // beforeDestroy () {
  //   // Clean up event listeners
  //   this.$bus.$off('apply-filters-tracking-bulk')
  //   this.$bus.$off('refresh-tracking-bulk')
  //   this.$bus.$off('export-tracking-bulk')
  //
  //   // Nettoie le filtre côté tracking sur chaque moteur en ligne
  //   const engines = this.$engine?.engines ?? []
  //   for (let i = 0; i < engines.length; i++) {
  //     const engine = this.$engine.get(i)
  //     if (engine && engine.common?.network?.state !== 'offline' && engine?.tracking?.cleanFilterCondition) {
  //       engine.tracking.cleanFilterCondition()
  //     }
  //   }
  // },
  methods: {
    bindBus () {
      // évite d’empiler
      if (this._busBound) return
        this.$bus.$on('apply-filters-tracking-bulk', this._onApplyFilters)
        this.$bus.$on('refresh-tracking-bulk', this._onRefreshBulk)
        this.$bus.$on('export-tracking-bulk', this._onExportBulk)
        this._busBound = true
    },

    unbindBus () {
      if (!this._busBound) return
        this.$bus.$off('apply-filters-tracking-bulk', this._onApplyFilters)
        this.$bus.$off('refresh-tracking-bulk',       this._onRefreshBulk)
        this.$bus.$off('export-tracking-bulk',        this._onExportBulk)
        this._busBound = false
    },
    async fetchBulkAndMerge(filterConditions) {
      this.activateSpinner = true;

      let merged = [];
      let nbTotal = 0;

      const engines = this.$engine?.engines ?? [];
      for (let i = 0; i < engines.length; i++) {
        const engine = this.$engine.get(i);
        if (!engine || engine.common?.network?.state === 'offline') continue;
        if (!engine?.tracking?.getTracksBulk) continue;
        try {
          const resp = await engine.tracking.getTracksBulk(filterConditions);
          if (!resp?.data) continue;
          nbTotal += Number(resp.data.nbTotaltrackingBulk || 0);
          const chunk = (resp.data.trackingBulk || []).map(r => ({ ...r, engineIndex: i }));
          merged.push(...chunk);
        } catch (e) {
          errorMessageAlert(e, this);
        }
      }

      // total
      this.paginationObject.nbResultsTotal = nbTotal;

      // tri DESC sur la date
      merged.sort((a, b) => new Date(b?.Date || 0) - new Date(a?.Date || 0));

      // découpe client pour la page demandée
      const perPage = this.paginationObject.maxResults
      const pageNumber = this.normalizeToPage(this.paginationObject.firstIndex) // marche si firstIndex=2 ou 16
      const start = (pageNumber - 1) * perPage
      const end = start + perPage
      const pageSlice = merged.slice(start, end)

      this.paginationObject.nbResults = pageSlice.length
      // si l’API ne renvoie pas bien le total, on retombe sur merged.length
      if (!this.paginationObject.nbResultsTotal) {
        this.paginationObject.nbResultsTotal = merged.length
      }
      this.paginationObject.hasNext = end < this.paginationObject.nbResultsTotal

      this.updateInbox(pageSlice);
      this.activateSpinner = false;
    },
    normalizeToPage(index) {
      const per = this.paginationObject.maxResults || 15
      if (typeof index !== 'number' || isNaN(index) || index < 1) return 1
      // si index == 1, 16, 31... => offset -> on convertit en numéro de page
      if (index === 1 || index > per || index % per === 1) {
        return Math.floor((index - 1) / per) + 1
      }
      // sinon on considère que c’est déjà un numéro de page (1,2,3…)
      return index
    },
    translateStatusFile(status) {
      const key = `tracking.status-${status}`;
      const translation = this.$t(key);

      if (translation === key) {
        return `Inconnu (${status})`;
      }

      return translation;
    },
    translateFileType(type) {
      // rien ou valeur non-chaîne → tiret
      if (type == null) return '-';

      // normaliser l'entrée
      const key = String(type).trim().toUpperCase();
      if (!key) return '-';

      // Types connus
      const typeMap = {
        VIREMENT_INST: this.$t('tracking.file_type_virement_inst'),
        VIP: this.$t('tracking.file_type_virement_inst'),
        SCT: this.$t('tracking.file_type_sct'),
        SEPA: this.$t('tracking.file_type_sct'),
        INST: this.$t('tracking.file_type_virement_inst'),
      };

      // si pas dans le map → '-'
      return Object.prototype.hasOwnProperty.call(typeMap, key)
        ? typeMap[key]
        : '-';
    },
    translateFinalStatus(status) {
      // Valeur vide → tiret
      if (status == null || status === '') return '-';

      // Normalisation (trim, minuscules, sans accents)
      const norm = String(status)
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      const map = new Map([
        ['traitee (ok)',       this.$t('tracking.final_status_processed')],
        ['traitée (ok)',       this.$t('tracking.final_status_processed')], // au cas où déjà accentué
        ['erreur (ko)',        this.$t('tracking.final_status_error')],
        ['partially processed', this.$t('tracking.final_status_partielTraite')],
      ]);

      if (map.has(norm)) return map.get(norm);

      // Petites tolérances (au cas où la valeur varie légèrement)
      if (/(traite|ok)/.test(norm))         return this.$t('tracking.final_status_processed');
      if (/(erreur|ko|error)/.test(norm))   return this.$t('tracking.final_status_error');
      if (/(partial|partiel)/.test(norm))   return this.$t('tracking.final_status_partielTraite');

      // Si rien ne correspond, on affiche la valeur d'origine
      return status;
    },
    applyFilter (filterConditions = {}) {
      this.TracksList = [];
      this.filterTypeGet = 'list';

      // reset pagination
      this.pageCounter = 0;
      this.paginationObject['firstIndex'] = 1;
      this.paginationObject['nbResultsTotal'] = 0;

      // rebuild conditions depuis les props
      filterConditions.Name = (this.filters.Name || '').trim();
      filterConditions.dateEnd = this.filters.dateEnd !== '' ? moment(this.filters.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '';
      filterConditions.dateBegin = this.filters.dateBegin !== '' ? moment(this.filters.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '';
      filterConditions.BicEntity = (this.filters.BicEntity || '').trim();
      filterConditions.BicBillable = (this.filters.BicBillable || '').trim();
      filterConditions.FinalStatus = this.filters.FinalStatus || '';
      filterConditions.StatusFile = this.filters.StatusFile || '';
      filterConditions.maxResults = this.paginationObject.maxResults;
      filterConditions.firstIndex = this.paginationObject.firstIndex;

      this.fetchBulkAndMerge(filterConditions);
    },
    // applyFilter (filterConditions = {}) {
    //   this.TracksList = []
    //   let that = this
    //   this.filterTypeGet = 'list'
    //
    //   if (this.$engine.get(this.engineIndex).common.network.state !== 'offline') {
    //     this.$engine.get(this.engineIndex).tracking.cleanFilterCondition()
    //   }
    //
    //   filterConditions.Name = this.filters.Name
    //   filterConditions.dateEnd =  this.filters.dateEnd != '' ?  moment(this.filters.dateEnd , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
    //   filterConditions.dateBegin =  this.filters.dateBegin != '' ?  moment(this.filters.dateBegin , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
    //   filterConditions.maxResults = this.paginationObject.maxResults
    //   filterConditions.firstIndex = this.paginationObject.firstIndex
    //
    //   this.pageCounter = 0
    //   this.paginationObject['firstIndex'] = 1
    //   this.paginationObject['nbResultsTotal'] = 0
    //   this.activateSpinner = true
    //
    //   if (engine.common.network.state !== 'offline') {
    //     engine.tracking.getTracksBulk(
    //       filterConditions
    //     ).then(resp => {
    //       let requests = {}
    //       that.paginationObject.nbResultsTotal = resp.data.nbTotaltrackingBulk
    //       that.paginationObject.nbResults = resp.data.trackingBulk.length
    //       requests = resp.data.trackingBulk
    //       requests.forEach(item => {
    //         item.engineIndex = that.engineIndex
    //       })
    //       that.updateInbox(requests)
    //       // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
    //       that.activateSpinner = false
    //     })
    //     .catch(error => {
    //       errorMessageAlert(error, that)
    //     })
    //   }
    // },
    canViewExtract () {
      return this.$engine.firstOn().rights.rightIs('tracks_consult_extract', true)
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      // Géré par le parent maintenant
      this.communicateChange()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved || this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set?.({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set?.({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    // attachInfinit () {
    //   if (this.$settings.inboxPreloaderRemoved ||
    //       this.$settings.sendboxPreloaderRemoved) {
    //     this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
    //
    //     if (this.$engine.get(this.engineIndex).common.network.state !== 'offline') {
    //       this.$engine.get(this.engineIndex).settings.set({inboxPreloaderRemoved: false})
    //     }
    //   }
    //   this.scrollFlag = true
    //   this.noMore = false
    // },
    // detachInfinit () {
    //   this.$$('.infinite-scroll-preloader').remove()
    //   this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
    //
    //   if (this.$engine.get(this.engineIndex).common.network.state !== 'offline') {
    //     this.$engine.get(this.engineIndex).settings.set({inboxPreloaderRemoved: true})
    //   }
    //   if (!this.emptyBox) {
    //     this.scrollFlag = false
    //     this.noMore = true
    //   }
    // },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh(noAttach = false, index = 1) {
      this.pageCounter = 0

      const perPage = this.paginationObject.maxResults
      const pageNumber = this.normalizeToPage(index)

      // on normalise toujours firstIndex en *offset de départ* (1, 16, 31…)
      this.paginationObject.firstIndex = (pageNumber - 1) * perPage + 1

      const filterConditions = {
        Name: (this.filters.Name || '').trim(),
        dateEnd: this.filters.dateEnd ? moment(this.filters.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        dateBegin: this.filters.dateBegin ? moment(this.filters.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        BicEntity: (this.filters.BicEntity || '').trim(),
        BicBillable: (this.filters.BicBillable || '').trim(),
        FinalStatus: this.filters.FinalStatus || '',
        StatusFile: this.filters.StatusFile || '',
        Type: this.tabName === 1 ? 'DDV' : 'DDD',

        // bulk backend fragile → on récupère "jusqu'à" la fin de la page demandée
        firstIndex: 1,
        maxResults: pageNumber * perPage
      }

      this.fetchBulkAndMerge(filterConditions)
    },
    // onRefresh (noAttach = false, index = 1) {
    //   let that = this
    //   this.pageCounter = 0
    //   this.paginationObject['firstIndex'] = index
    //   this.paginationObject['nbResultsTotal'] = 0
    //
    //   this.activateSpinner = true
    //   let filterConditions = {
    //
    //     Name: this.filters.Name,
    //     dateEnd: this.filters.dateEnd != '' ?  moment(this.filters.dateEnd , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
    //     dateBegin: this.filters.dateBegin != '' ?  moment(this.filters.dateBegin , 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
    //     maxResults :this.paginationObject.maxResults,
    //     firstIndex :this.paginationObject.firstIndex,
    //   }
    //
    //   if (this.$engine.get(this.engineIndex).common.network.state !== 'offline') {
    //     this.$engine.get(this.engineIndex).tracking.getTracksBulk(
    //       filterConditions
    //     ).then(resp => {
    //       this.TracksList = []
    //       let requests = {}
    //       if (resp.data) {
    //         that.paginationObject.nbResultsTotal = resp.data.nbTotaltrackingBulk
    //         that.paginationObject.nbResults = resp.data.nbTotaltrackingBulk
    //         requests = resp.data.trackingBulk
    //         requests.forEach(item => {
    //           item.engineIndex = that.engineIndex
    //         })
    //         that.updateInbox(requests, noAttach)
    //         that.$f7.pullToRefreshDone()
    //         that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
    //       }
    //       that.activateSpinner = false
    //
    //     })
    //     .catch(error => {
    //       that.activateSpinner = false
    //       errorMessageAlert(error, that)
    //     })
    //   }
    // },

    async extractCSV () {
      if (this._exporting) return;
      this._exporting = true;
      this.activateSpinner = true;

      try {
        // Helpers binaires
        const b64ToBytes = (b64) => {
          const bin = atob(b64);
          const out = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
          return out;
        };
        const bytesToB64 = (bytes) => {
          let bin = '';
          const chunk = 0x8000;
          for (let i = 0; i < bytes.length; i += chunk) {
            bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
          }
          return btoa(bin);
        };
        const concat = (arrays) => {
          const total = arrays.reduce((a, b) => a + b.length, 0);
          const out = new Uint8Array(total);
          let o = 0;
          arrays.forEach(a => { out.set(a, o); o += a.length; });
          return out;
        };
        const findHeaderEnd = (bytes) => {
          let i = 0;
          // saute BOM UTF-8
          if (bytes.length >= 3 && bytes[0] === 0xEF && bytes[1] === 0xBB && bytes[2] === 0xBF) i = 3;
          for (; i < bytes.length; i++) {
            if (bytes[i] === 0x0A) return i + 1; // LF
            if (bytes[i] === 0x0D) return (bytes[i + 1] === 0x0A) ? i + 2 : i + 1; // CRLF/CR
          }
          return bytes.length;
        };
        const ensureLF = (bytes) => {
          const n = bytes.length;
          if (!n || bytes[n - 1] === 0x0A) return bytes;
          const out = new Uint8Array(n + 1);
          out.set(bytes); out[n] = 0x0A;
          return out;
        };

        // Conditions d’export
        const filterConditions = {
          extract: 2, // <-- export fichiers (header + lignes)
          Name: (this.filters.Name || '').trim(),
          dateBegin: this.filters.dateBegin ? moment(this.filters.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
          dateEnd:   this.filters.dateEnd   ? moment(this.filters.dateEnd,   'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ')   : '',
          BicEntity: (this.filters.BicEntity || '').trim(),
          BicBillable: (this.filters.BicBillable || '').trim(),
          FinalStatus: this.filters.FinalStatus || '',
          StatusFile:  this.filters.StatusFile  || '',
          Type: this.tabName === 1 ? 'DDV' : 'DDD',
          // on ne limite PAS par page pour un export global
          firstIndex: 1,
          maxResults: 999999
        };

        // Récupérer tous les silos en parallèle
        const engines = this.$engine?.engines ?? [];
        const promises = engines.map((_, i) => {
          const engine = this.$engine.get(i);
          if (!engine || engine.common?.network?.state === 'offline' || !engine?.tracking?.getTracksBulk) {
            return Promise.resolve(null);
          }
          return engine.tracking.getTracksBulk(filterConditions)
            .then(r => (typeof r?.data === 'string' && r.data.length) ? r.data : null)
            .catch(() => null);
        });

        const results = (await Promise.all(promises)).filter(Boolean);
        if (!results.length) {
          this.activateSpinner = false;
          this._exporting = false;
          this.$nextTick(() => this.$f7.alert('', this.$t('common.no_result')));
          return;
        }

        // Fusion : on garde le header du premier, on retire les headers suivants
        let first = ensureLF(b64ToBytes(results[0]));
        const bodies = results.slice(1).map(b64 => {
          const bytes = b64ToBytes(b64);
          const cut = findHeaderEnd(bytes);
          return cut < bytes.length ? bytes.subarray(cut) : new Uint8Array(0);
        });

        let finalBytes = concat([first, ...bodies]);  // <-- let, pas const

        // --- helpers encodage ---
        const decodeBestEffort = (bytes) => {
        // 1) UTF-8
        let txt = new TextDecoder('utf-8').decode(bytes);
        // heuristique mojibake
        const looksBroken = /Ã.|Â.|ï¿½|�/.test(txt);
        if (looksBroken) {
          try { txt = new TextDecoder('windows-1252').decode(bytes); } catch {}
        }
        return txt;
      };
      const encodeUtf8WithBom = (text) => {
        const utf8 = new TextEncoder().encode(text);
        const out = new Uint8Array(utf8.length + 3);
        out.set([0xEF, 0xBB, 0xBF]);
        out.set(utf8, 3);
        return out;
      };

      try {
        const csvText = decodeBestEffort(finalBytes);

        const SEP = ';';
        const lines = csvText.split(/\r?\n/);
        if (lines.length > 1) {
          const header = lines[0];
          const headers = header.split(SEP);

          // normalisation: retire guillemets, trim, minuscule, enlève diacritiques
          const norm = s => s
            .replace(/^"|"$/g, '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

          // indices des colonnes à traiter
          let idxEtat = headers.findIndex(h => norm(h) === 'etat du traitement');
          if (idxEtat < 0) idxEtat = headers.length - 1; // fallback: dernière

          const idxType = headers.findIndex(h => norm(h) === 'type de fichier');

          const isOneOf = (h, arr) => arr.includes(norm(h));
          const idxFinal = headers.findIndex(h =>
            isOneOf(h, [
              'statut final du traitement',
              'statut final',
              'final status',
              'final status of processing',
              'final_status',
              'finalstatus'
            ])
          );

          const newLines = [header];
          for (let i = 1; i < lines.length; i++) {
            const line = lines[i];
            if (!line.trim()) { newLines.push(line); continue; }

            const cells = line.split(SEP);

            // ---- Statut final du traitement -> libellé i18n
            if (idxFinal >= 0 && idxFinal < cells.length) {
              const rawFinal = (cells[idxFinal] || '').trim().replace(/^"|"$/g, '');
              if (rawFinal) {
                const translatedFinal = this.translateFinalStatus(rawFinal);
                cells[idxFinal] = `"${translatedFinal}"`;
              } else {
                cells[idxFinal] = '"-"';
              }
            }

            // ---- Etat du traitement -> libellé
            if (idxEtat >= 0 && idxEtat < cells.length) {
              const rawEtat = (cells[idxEtat] || '').trim().replace(/^"|"$/g, '');
              if (rawEtat) {
                const translatedEtat = this.translateStatusFile(rawEtat);
                cells[idxEtat] = `"${translatedEtat}"`;
              }
            }

            // ---- Type de fichier -> libellé
            if (idxType >= 0 && idxType < cells.length) {
              const rawType = (cells[idxType] || '').trim().replace(/^"|"$/g, '');
              if (rawType) {
                const outType = this.translateFileType(rawType); // renvoie '-' si inconnu
                cells[idxType] = `"${outType}"`;
              } else {
                cells[idxType] = '"-"';
              }
            }

            newLines.push(cells.join(SEP));
          }

          const outText = newLines.join('\r\n');
          finalBytes = encodeUtf8WithBom(outText); // UTF-8 + BOM -> Excel gère les accents
        }
      } catch (_) {
        // si parsing raté, on laisse finalBytes tel quel
      }

        const b64Final = bytesToB64(finalBytes);
        const href = 'data:text/csv;charset=utf-8;base64,' + b64Final;
        const fileName = this.$t('Webheader.tracking_bulk') + '_' + moment.tz().unix() + '.csv';

        if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
          // ton helper garde les bons headers côté App
          downloadFileWithDefinedHeaders(this, fileName, href);
        } else {
          const a = document.createElement('a');
          a.href = href;
          a.download = fileName;
          a.click();
        }

        this.$nextTick(() => this.$f7.alert('', this.$t('common.exprt_succ')));
      } catch (e) {
        errorMessageAlert(e, this);
      } finally {
        this.activateSpinner = false;
        this._exporting = false;
      }
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    changeTabName (tabName) {
      this.tabName = tabName
      this.onRefresh()
    },
    activateDetail (id, engineIndex) {
      loadPage(this, { url: '/trackingbulk/' + id + '/' + engineIndex })
    },
    reOrderBy (column) {
      // toggle sens
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        this.sortDirection = (column === 'dateAction') ? 'DESC' : 'ASC'
      }
    },

    // reOrderBy (column) {
    //   this.TracksList = []
    //   let that = this
    //   if (this.sortField === column) {
    //     this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
    //   } else {
    //     this.sortField = column
    //     switch (column) {
    //       case 'dateAction':
    //         this.sortDirection = 'DESC'
    //     }
    //   }
    //   let filterConditions
    //
    //   if (this.$engine.get(this.engineIndex).common.network.state !== 'offline') {
    //     this.$engine.get(this.engineIndex).tracking.getTracksBulk(
    //       this.paginationObject.maxResults,
    //       this.paginationObject.firstIndex,
    //       filterConditions
    //     ).then(resp => {
    //       let requests = {}
    //       that.paginationObject.nbResultsTotal = resp.data.nbTotaltrackingBulk
    //       that.paginationObject.nbResults = resp.data.trackingBulk.length
    //       requests = resp.data.trackingBulk
    //       requests.forEach(item => {
    //         item.engineIndex = that.engineIndex
    //       })
    //       that.updateInbox(requests, false)
    //       that.$f7.pullToRefreshDone()
    //       that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
    //       that.activateSpinner = false
    //     })
    //     .catch(error => {
    //       that.activateSpinner = false
    //       errorMessageAlert(error, that)
    //     })
    //   }
    // },
    updateInbox (requests, noAttach = false) {
      this.TracksList = requests;

      const perPage = this.paginationObject.maxResults;
      const page = Math.max(1, Number(this.paginationObject.firstIndex || 1));
      const end = page * perPage;

      // attache/détache l’infinite scroll en fonction du next réel
      if (end < this.paginationObject.nbResultsTotal) {
        if (!noAttach) this.attachInfinit();
      } else {
        this.detachInfinit();
      }
    },
    seeTracksDetails (item) {
      this.activateDetail(item.idTrackingBulk, item.engineIndex)
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    seeJson (IdMsg, service, action) {
      let that = this
      const id = IdMsg
      let dataDetails = {}

      if (this.$engine.get(this.engineIndex).common.network.state !== 'offline') {
        this.$engine.get(this.engineIndex).tracking.getJSON({service, id})
        .then((resp) => {
          if (resp.data) {
            dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
            dataDetails.type = service
            if (action === 'see') {
              that.$bus.emit('popup-json-details', dataDetails)
            } else {
              //download file
              let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
              // if (this.isXML(data)){
              //   const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.xml'
              //   const blob = new Blob([data], { type: 'text/xml' })
              //
              //   downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              //   that.$f7.alert('', that.$i18n.t('common.xml_downloaded'))
              // }
              // if (this.isJSON(data)){
              //   const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.json'
              //   const blob = new Blob([data], { type: 'application/json' })
              //
              //   downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              //   that.$f7.alert('', that.$i18n.t('common.json_downloaded'))
              // }
              if (this.isCSV(data)){
                const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.csv'
                const blob = new Blob([data], { type: 'text/csv' })

                downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
                that.$f7.alert('', that.$i18n.t('common.csv_downloaded'))
              }
            }
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
      }
    },
    canAddTrackingFile () {
      return this.$engine.firstOn().rights.rightIs('tracking_bulk_add', true)
    },
    addTrackingFile () {
      let that = this
      loadPage(that, {url: '/trackingform/create/'})
    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>
